import React from 'react';

const ClientsWidget = ({ clients, onCreate, onEdit, onDelete }) => {
  return (
    <div className="bg-zinc-900 rounded-lg shadow p-6 h-full flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-white">Clientes</h2>
        <button
          className="bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded"
          onClick={onCreate}
        >
          Novo Cliente
        </button>
      </div>
      <div className="overflow-auto flex-1">
        <table className="min-w-full text-sm text-gray-300">
          <thead>
            <tr className="bg-zinc-800">
              <th className="px-4 py-2 text-left">Nome</th>
              <th className="px-4 py-2 text-left">Telefone</th>
              <th className="px-4 py-2 text-left">Email</th>
              <th className="px-4 py-2 text-left">Ações</th>
            </tr>
          </thead>
          <tbody>
            {clients.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center py-8 text-gray-500">Nenhum cliente cadastrado.</td>
              </tr>
            ) : (
              clients.map((client, idx) => (
                <tr key={client.id} className="odd:bg-gray-100 even:bg-white odd:text-black even:text-black">
                  <td className="px-4 py-2 font-medium">{client.nome}</td>
                  <td className="px-4 py-2">{client.telefone}</td>
                  <td className="px-4 py-2">{client.email}</td>
                  <td className="px-4 py-2 space-x-2">
                    <button
                      className="text-orange-400 hover:underline"
                      onClick={() => onEdit(client)}
                    >
                      Editar
                    </button>
                    <button
                      className="text-red-400 hover:underline"
                      onClick={() => onDelete(client)}
                    >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientsWidget;
